import { DynamicPageProps } from '@doltech/routeDefinition';
import * as React from 'react';
import styled from 'styled-components';

import { BlogCard } from '../../blog-landing/components/BlogCard';
import { ListingForLandingBlog } from '../../landing-blog/ListingForLandingBlog';

const Container = styled.section``;

interface LandingGrammarProps extends DynamicPageProps {}

const TOP_SECTION = 'landing-blog-listing';
export const LandingGrammar = (props: LandingGrammarProps) => {
  const { pageData, seoData } = props;
  const { blogData } = pageData;

  return (
    <Container id={TOP_SECTION}>
      <ListingForLandingBlog
        data={blogData?.content || []}
        renderCard={({ item }) => <BlogCard data={item} />}
        pageSize={10}
        pageInfo={blogData}
        currentPageUrl={seoData?.url}
        supportSEO
      />
    </Container>
  );
};
